<!-- No outputs bound: on the link path none can fire, the result screens end the page. -->
<main class="order-page" data-testid="sip-order-page">
	<div class="order-page__card" [class.order-page__card--wide]="store.phase() === 'order'" data-testid="sip-order-card">
		<app-guided-setup
			[entry]="'link'"
			[hideStepRail]="true"
			[monthlyCost]="monthlyCost()"
			[signals]="signals()"
		></app-guided-setup>
	</div>
</main>
